/* eslint-disable import/no-anonymous-default-export */
/**
 * 당근 비즈 프로필 후기 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: "adBizProfile",
  title: "당근 비즈 프로필 후기 신청",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type",
      params: { type: "biz_profile" },
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type/count",
      params: { type: "biz_profile" },
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
      version: 2,
      type: "biz_profile",
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns/by-type",
    },
  },

  filters: {
    default: {
      status: "전체",
      submitDate: "",
      keyword: "",
      page: 1,
      limit: 50,
      submitted: "전체",
      paid: "전체",
    },
    schema: [
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 플레이스명",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "진행중" },
          { value: "completed", label: "종료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "진행중" },
      { key: "completedCount", label: "종료" },
    ],
  },

  table: {
    keyField: "adBizProfileId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.userName}
              {row.userId ? ` (${row.userId})` : ""}
            </div>
            <div>
              <span className={`badge badge-${row.status}`}>{getStatusLabel(row.status)}</span>
            </div>
          </>
        ),
      },
      {
        key: "submitDate",
        label: "접수일",
        center: true,
        render: (row) => (row.submitDate ? row.submitDate.split("T")[0] : ""),
      },
      {
        key: "title",
        label: "상품명\n업체명\n총수량(일수량/진행일)",
        center: true,
        width: "150px",
        render: (row) => {
          const total = row.totalCount || 0;
          const daily = row.dailyCount || 0;
          const days = daily > 0 ? Math.ceil(total / daily) : 0;
          return (
            <>
              <div>{row.title || "당근 비즈 프로필 후기"}</div>
              <div>{row.placeName || "-"}</div>
              <div>{total}건({daily}건/{days}일)</div>
            </>
          );
        },
      },
      {
        key: "phoneNum",
        label: "연락처\n비즈프로필 URL",
        center: true,
        render: (row) => (
          <>
            <div>{row.phoneNum || ""}</div>
            <div>
              {row.bizProfileUrl && (
                <a href={row.bizProfileUrl} target="_blank" rel="noopener noreferrer">
                  {row.bizProfileUrl}
                </a>
              )}
            </div>
          </>
        ),
      },
      {
        key: "guideline",
        label: "요청사항(가이드라인)",
        center: false,
        render: (row) => row.guideline || "-",
      },
      {
        key: "totalAmount",
        label: "총금액",
        center: true,
        render: (row) => (row.totalAmount ? `${row.totalAmount.toLocaleString()}원` : ""),
      },
      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>{row.paymentType === "card" ? "카드" : row.paymentType === "v_bank" ? "가상계좌" : row.paymentType === "point" ? "포인트 결제" : "계좌이체"}</div>
            <div>
              {row.isRefunded === 1 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row, handlers) => (
          <button
            type="button"
            className="status-btn submitted"
            onClick={(e) => {
              e.stopPropagation();
              if (handlers && handlers.openReportModal) {
                handlers.openReportModal(row.adCampaignMetaId, row.placeName);
              }
            }}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productName = "당근 비즈 프로필 후기";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalAmount ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) => selectedIds.includes(item.adBizProfileId));
        const adCampaignMetaIds = [...new Set(selectedItems.map((item) => item.adCampaignMetaId).filter((id) => id))];
        const hasUnsubmitted = selectedItems.some((item) => item.isSubmitted !== 1);
        return {
          type: "biz_profile",
          action: "submitted",
          ids: adCampaignMetaIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "complete",
      label: "완료(종료)",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: (selectedIds, items) => {
        const hasUncompleted = items.some(
          (item) => selectedIds.includes(item.adBizProfileId) && item.isCompleted !== 1,
        );
        return hasUncompleted ? "선택한 신청을 완료 처리하시겠습니까?" : "선택한 신청을 취소 처리하시겠습니까?";
      },
      payloadBuilder: (selectedIds, items) => {
        const hasUncompleted = items.some(
          (item) => selectedIds.includes(item.adBizProfileId) && item.isCompleted !== 1,
        );
        return {
          type: "biz_profile",
          action: "completed",
          ids: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some((item) => selectedIds.includes(item.adBizProfileId) && item.isPaid === 1);
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) => selectedIds.includes(item.adBizProfileId));
        const adPaymentTransactionIds = [
          ...new Set(selectedItems.map((item) => item.adPaymentTransactionId).filter((id) => id)),
        ];
        return {
          type: "biz_profile",
          action: "paid",
          ids: adPaymentTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adBizProfileId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: "선택한 신청을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        const filteredSelectedIds = items
          .filter((item) => selectedIds.includes(item.adBizProfileId))
          .map((item) => item.adBizProfileId);
        return {
          type: "biz_profile",
          ids: filteredSelectedIds,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    fileName: "당근비즈프로필리뷰_신청목록.xlsx",
    sheetName: "당근비즈프로필리뷰신청목록",
    transformRow: (row) => {
      const total = row.totalCount || 0;
      const daily = row.dailyCount || 0;
      const days = daily > 0 ? Math.ceil(total / daily) : 0;
      return {
        신청자: row.userName || "",
        접수일: row.submitDate ? row.submitDate.split("T")[0] : "",
        상품명: row.title || "당근 비즈 프로필 후기",
        업체명: row.placeName || "",
        일수량: daily,
        진행일: days,
        총수량: total,
        연락처: row.phoneNum || "",
        비즈프로필URL: row.bizProfileUrl || "",
        총금액: row.totalAmount || 0,
        결제방법: row.paymentType === "card" ? "카드" : row.paymentType === "v_bank" ? "가상계좌" : row.paymentType === "point" ? "포인트 결제" : "계좌이체",
        요청사항: row.guideline || "",
      };
    },
  },
};

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "진행중";
    case "completed":
      return "종료";
    default:
      return status;
  }
}
